<template>
  <div>
    <div id="map" class="w-100"></div>
  </div>
</template>

<script>
import gisMixin from "../../mixins/gis";
import { Loader } from "@googlemaps/js-api-loader";

export default {
  data() {
    return {
      map: null,
      isMapLoaded: false,
      defaultLat: "28.555278",
      defaultLong: "77.209578",
    };
  },

  mixins: [gisMixin],

  async mounted() {
    this.loadMyMap();
  },

  computed: {
    gisDevices() {
      return this.$store.getters["gis/devices"];
    },
    location() {
      return this.$store.getters["socket/dashboard"].statistics.location;
    },
  },

  watch: {
    location: function () {
      if (this.location && !this.isMapLoaded) {
        this.loadMyMap();
      }
    },
  },

  methods: {
    async loadMyMap() {
      if (this.location && !this.isMapLoaded) {
        this.isMapLoaded = true;
        const loader = new Loader({
          apiKey: "AIzaSyAsjTYlNYOvHXj8GV72iYJjxbit6eMGt1U",
          version: "weekly",
        });

        const lat = this.location.center_lat
          ? parseFloat(this.location.center_lat).toFixed(3)
          : parseFloat(this.defaultLat).toFixed(3);
        const long = this.location.center_long
          ? parseFloat(this.location.center_long).toFixed(3)
          : parseFloat(this.defaultLong).toFixed(3);

        if (parseFloat(this.location.center_lat).toFixed(3) !== lat)
          this.isMapLoaded = false;

        loader
          .load()
          .then(() => {
            this.map = new google.maps.Map(document.getElementById("map"), {
              center: {
                lat: parseFloat(lat),
                lng: parseFloat(long),
              },
              zoom: 12,
              minZoom: 12 - 3,
              maxZoom: 11,
              streetViewControl: false,
              mapTypeControl: false,
              styles: [
                {
                  elementType: "labels",
                  stylers: [
                    {
                      visibility: "on",
                    },
                  ],
                },
                {
                  featureType: "administrative.country",
                  elementType: "labels",
                  stylers: [
                    {
                      visibility: "on",
                    },
                  ],
                },
                {
                  featureType: "administrative.locality",
                  elementType: "labels",
                  stylers: [
                    {
                      visibility: "on",
                    },
                  ],
                },
                {
                  featureType: "road",
                  stylers: [
                    {
                      visibility: "off",
                    },
                  ],
                },
                {
                  stylers: [{ hue: "#00ffe6" }, { saturation: -20 }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ lightness: 100 }, { visibility: "simplified" }],
                },
                {
                  featureType: "road",
                  elementType: "labels",
                  stylers: [{ visibility: "off" }],
                },
                { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                {
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#242f3e" }],
                },
                {
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#746855" }],
                },
                {
                  featureType: "administrative.locality",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#84654d" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry",
                  stylers: [{ color: "#0D5060" }],
                },
                {
                  featureType: "road",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#0D5060" }],
                },
                {
                  featureType: "road",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#0D5060" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry",
                  stylers: [{ color: "#0D5060" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "geometry.stroke",
                  stylers: [{ color: "#ffffff" }],
                },
                {
                  featureType: "road.highway",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#ffffff" }],
                },
                {
                  featureType: "transit",
                  elementType: "geometry",
                  stylers: [{ color: "#2f3948" }],
                },
                {
                  featureType: "transit.station",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#d59563" }],
                },
                {
                  featureType: "water",
                  elementType: "geometry",
                  stylers: [{ color: "#17263c" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.fill",
                  stylers: [{ color: "#515c6d" }],
                },
                {
                  featureType: "water",
                  elementType: "labels.text.stroke",
                  stylers: [{ color: "#17263c" }],
                },
              ],
            });

            this.loadRoute();
            this.loadDevices();
            // const trafficLayer = new google.maps.TrafficLayer();
            // trafficLayer.setMap(this.map);

            const i = setInterval(async () => {
              try {
                await this.hideFullscreenButton();
                clearInterval(i);
              } catch (e) {}
            }, 10);
          })
          .catch((e) => {
            console.error(e);
            // this.isMapLoaded = false;
          });
      }
    },

    async hideFullscreenButton() {
      const fullscreenControl = document.querySelector(
        ".gm-fullscreen-control"
      );

      fullscreenControl.style.display = "none";
    },

    loadDevices() {
      if (this.gisDevices.length > 0 && this.map) {
        let side = "LHS";
        for (let index in this.gisDevices) {
          let markerImage = null;
          let markerType = "anpr";
          let marker = null;
          let position = null;

          if (String(this.gisDevices[index].device_type).includes("ANPR"))
            markerType = "anpr";
          if (String(this.gisDevices[index].device_type).includes("AVC"))
            markerType = "avc";
          if (String(this.gisDevices[index].device_type).includes("VMS"))
            markerType = "vms";
          if (String(this.gisDevices[index].device_type).includes("ECB"))
            markerType = "ecb";
          if (String(this.gisDevices[index].device_type).includes("SWITCH"))
            markerType = "switch";

          if (this.gisDevices[index].lat && this.gisDevices[index].long) {
            if (side === "LHS") {
              side = "RHS";
              if (markerType === "anpr") markerImage = "cam-rhs-online.png";

              this.drawPolyline(
                this.gisDevices[index].lat,
                this.gisDevices[index].long,
                parseFloat(this.gisDevices[index].lat),
                parseFloat(this.gisDevices[index].long) - 0.1
              );

              position = {
                lat: parseFloat(this.gisDevices[index].lat) + 0.01,
                lng: parseFloat(this.gisDevices[index].long) - 0.12,
              };

            } else {
              side = "LHS";
              if (markerType === "anpr") markerImage = "cam-lhs-online.png";

              position = {
                lat: parseFloat(this.gisDevices[index].lat) + 0.01,
                lng: parseFloat(this.gisDevices[index].long) + 0.1,
              };

              this.drawPolyline(
                this.gisDevices[index].lat,
                this.gisDevices[index].long,
                parseFloat(this.gisDevices[index].lat),
                parseFloat(this.gisDevices[index].long) + 0.1
              );
            }

            // Draw marker
            marker = new google.maps.Marker({
              position: position,
              title: `${this.gisDevices[index].device_name}`,
              map: this.map,
              icon: {
                url: markerImage,
                scaledSize: new google.maps.Size(30, 30),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(0, 0),
              },
            });

            let infoWindow = new google.maps.InfoWindow({
              content: `
              <div class="text-left">
              <h4 class="text-light">${this.gisDevices[index].device_name}</h4>
              <h4 class="text-light">Status: ${this.gisDevices[index].status === true ? '<span class="text-success">Online</span>': '<span class="text-success">Offline</span>'}</h4>
              </div>`,
            });

            // On hover
            marker.addListener("mouseover", function () {
              infoWindow.open(map, this);
            });

            // assuming you also want to hide the infoWindow when user mouses-out
            marker.addListener("mouseout", function () {
              infoWindow.close();
            });

            // On click event
            google.maps.event.addListener(marker, "click", () => {
              this.$emit("loadDevice", JSON.stringify(this.gisDevices[index]));
            });
          }
        }
      }
    },

    loadRoute() {
      if (this.location) {
        var start = new google.maps.LatLng(
          parseFloat(this.location.start_lat),
          parseFloat(this.location.start_long)
        );
        var end = new google.maps.LatLng(
          parseFloat(this.location.end_lat),
          parseFloat(this.location.end_long)
        );

        var directionsDisplay = new google.maps.DirectionsRenderer(); // also, constructor can get "DirectionsRendererOptions" object
        directionsDisplay.setMap(this.map); // map should be already initialized.
        directionsDisplay.setOptions({
          polylineOptions: {
            strokeColor: "#e69138",
            strokeOpacity: 0.9,
            strokeWeight: 6,
          },
        });

        var request = {
          origin: start,
          destination: end,
          travelMode: google.maps.TravelMode.DRIVING,
        };

        var directionsService = new google.maps.DirectionsService();
        directionsService.route(request, function (response, status) {
          if (status == google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);

            // console.log(response);
            // for (let path of response.routes[0].overview_path) {
            //   console.log(path.lat());
            // }
          }
        });
      }
    },

    drawPolyline(startLat, startLong, endLat, endLong) {
      var coordinates = [
        { lat: parseFloat(startLat), lng: parseFloat(startLong) },
        { lat: parseFloat(endLat), lng: parseFloat(endLong) },
      ];

      new google.maps.Polyline({
        map: this.map,
        path: coordinates,
        geodesic: true,
        strokeColor: "#e69138",
        strokeOpacity: 1.0,
        strokeWeight: 1,
      });
    },
  },
};
</script>

<style scoped>
#map {
  /* width: 50%; */
  height: 100vh;
  margin: 0;
  padding: 0;
  border-radius: 5px;
}

#direction {
  color: #000;
  max-width: 99%;
  width: 300px;
  position: absolute;
  z-index: 999;
  font-size: 15px;
  padding: 10px;
  border: 1px solid #ddd;
  outline: none !important;
  top: 55px;
  border-radius: 10px;
  margin: 2px 4px;
}

#mLogo0 {
  display: none !important;
}

.map-default {
  position: absolute;
  left: 1.5%;
  top: 3%;
}
</style>
